import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App.vue'

import axios from './axios'
import validate from './plugins/validate.js'
import vSelect from 'vue-select'
import Autocomplete from 'vuejs-auto-complete'
import VueAutosuggest from 'vue-autosuggest'
import VueCurrencyFilter from 'vue-currency-filter'
import VuePageTransition from 'vue-page-transition'
import VueAxios from 'vue-axios'
import VueFormWizard from 'vue-form-wizard'
import Geocoder from '@pderas/vue2-geocoder'
import TrendChart from "vue-trend-chart";
import VueToast from 'vue-toast-notification';
import VueNumeric from 'vue-numeric'
import DatePicker from 'vue2-datepicker';
import VueApexCharts from 'vue-apexcharts'

import * as VueGoogleMaps from 'vue2-google-maps'

import { ValidationObserver } from 'vee-validate'
import { ModelListSelect } from 'vue-search-select'

import 'vue-select/dist/vue-select.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-toast-notification/dist/theme-default.css'
import 'vue2-datepicker/index.css';

const moment = require('moment')
require('moment/locale/id')

Vue.config.productionTip = false

Vue.component('v-select', vSelect)
Vue.component('ValidationProvider', validate);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ModelListSelect', ModelListSelect);
Vue.component('Autocomplete', Autocomplete);
Vue.component('DatePicker', DatePicker);
Vue.component('apexchart', VueApexCharts)

Vue.use(VueAxios, axios)
Vue.use(VueAutosuggest)
Vue.use(VuePageTransition)
Vue.use(VueFormWizard)
Vue.use(TrendChart)
Vue.use(VueToast)
Vue.use(VueNumeric)
Vue.use(VueApexCharts)

Vue.use(require('vue-moment'), {
    moment
})

Vue.use(VueCurrencyFilter, [
    {
        name: 'currency',
        symbol: 'Rp',
        thousandsSeparator: '.',
        fractionCount: 0,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    },
    {
        name: 'decimal',
        symbol: '',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    }
])
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDE-qJK1zkkJPgNoO9-QNniTBsjQ9Tv2Go',
        libraries: 'places',
    },
    installComponents: true
})
Vue.use(Geocoder, {
    defaultCountryCode: null, // e.g. 'CA'
    defaultLanguage: null, // e.g. 'en'
    defaultMode: 'lat-lng', // or 'lat-lng'
    googleMapsApiKey: 'AIzaSyDE-qJK1zkkJPgNoO9-QNniTBsjQ9Tv2Go'
});
Vue.filter('round', function(value) {
    var decimal = 3;
    
    if(!value) {
      value = 0;
    }    
  
    value = Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
    return value;
})

new Vue({
    store,
    router,
    render: h => h(App),
    mounted() {
        let _ = this
        _.$store.dispatch('tryAutoLogin')
    }
}).$mount('#app')